import React, { Fragment, useContext } from 'react'
import { TextsContext } from '../context/textsContext';
import Special from "../scss/text.module.scss";
import StyleStep from "../scss/step.module.scss";
import {useNavigate} from "react-router-dom";
import {useSteps, QUOTER_MODULES} from "../hooks/useSteps";
import { useValidation } from '../hooks/ValidationHook';
import { Icon } from '@iconify/react';

const StepComponents = () => {
	const { texts } = useContext(TextsContext);
	const {validateValues} = useValidation()
	const {getAllSteps, getIncompleteModules} = useSteps();
	const data = QUOTER_MODULES.map(({ id, labelKey, label }) => ({
		id,
		options: texts?.[labelKey] ?? label,
	}));

	const navigate = useNavigate();

	const currentPath = window.location.pathname;
	const allSteps = getAllSteps();
	const currentPathData = allSteps.find(i => i?.path === currentPath);

	const incompleteModules = getIncompleteModules();
	const pendingText = texts?.menu_options_pending_fields ?? 'This step has pending fields';

	const handleClick = (module) => {
		validateValues();
		navigate(getAllSteps().find(i => i?.module == module && !i?.ignore).path);
	};

  return (
	<Fragment>
		<ul className={StyleStep.StyleStep}>
			{
				data.map((user) => {
					// Sólo se marca un módulo anterior al que se está viendo: mientras el
					// usuario esté parado en el step, no se le muestra la X.
					const isPending = currentPathData?.module > user.id && incompleteModules.includes(user.id);

					return (
						<li key={user.id} title={isPending ? pendingText : undefined} className={`${StyleStep.step}
						${currentPathData?.module > user.id && StyleStep.stepPastVisited}
						${currentPathData?.module == user.id && StyleStep.stepVisited}
						${currentPathData?.module < user.id && StyleStep.stepNoVisited}
						${isPending && StyleStep.stepPending} `}>
							<span className={StyleStep.dot}>
								<Icon icon={isPending ? "mdi:close-thick" : "mdi:check-bold"} className={StyleStep.icon} />
							</span>
							<span onClick={() => handleClick(user.id)} className={`${StyleStep.texto}`}>{user.options}</span>
						</li>
					);
				})
			}
		</ul>
	</Fragment>
  )
}

export default StepComponents
